import React from "react";
import { graphql } from "gatsby";
import { renderContent } from "../utils/utils";
import CallToAction from "./CallToAction";
export default function ImageText(props) {
  return (
    <div className="bg-white hds-section">
      <div className="max-w-7xl mx-auto">
        <div className="bg-primary rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
          <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
            <div className="lg:self-center lit-rit-copy">
              {props.data.title && (
                <h3 className="text-white font-heading text-2xl">
                  {props.data.title}
                </h3>
              )}
              <div
                className="text-white text-lg font-body"
                dangerouslySetInnerHTML={renderContent(props.data.text)}
              />
              {props.data.callToAction && (
                <CallToAction data={props.data.callToAction[0]} /> // You can only have one CTA per page
              )}
            </div>
          </div>
          <div className="aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
            <img
              src={props.data.image.url}
              className="object-cover object-left-top"
              alt={props.data.image.alt}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export const imageTextQuery = graphql`
  fragment ImageTextComponent on DatoCmsImageText {
    text
    title
    id
    image {
      alt
      url
      gatsbyImageData
    }
    callToAction {
      buttonText
      buttonColor {
        hex
      }
      buttonLinkUrl
    }
    internal {
      type
    }
  }
`;
